module.exports = __webpack_public_path__ + "media/images/icon_note-bd763e07.png";